import { newSidebarRoutes } from "../Sidebar/NavLink";

export const getRoutObjByKey = (route_key) => {
  let routes = newSidebarRoutes;
  if (!routes.length) return null;
  for (let i = 0; i < routes.length; i++) {
    const route = routes[i];
    const { key, childs } = route;
    if (route_key === key) return route;
    if (childs.length) {
      for (let childIndex = 0; childIndex < childs.length; childIndex++) {
        if (childs?.[childIndex]?.key === route_key) return childs?.[childIndex];
      }
    }
  }
  return null;
};
export const getRoutObjByUrl = (url) => {
  let _url = url.slice(1);
  let routes = newSidebarRoutes;
  if (!routes.length) return null;
  let route_key = ''
  for (let i = 0; i < routes.length; i++) {
    const route = routes[i];
    const { key, childs , url} = route;
    if (_url === url) {
      route_key = key
      break;
    };
    if (childs?.length) {
      for (let childIndex = 0; childIndex < childs.length; childIndex++) {
        if (childs?.[childIndex]?.url === _url) {
           route_key =key+"*"+childs?.[childIndex]?.key;
           break;
        };
      }
    }
  }
  return route_key;
};
